import axios from '@/http/axios';
import {route} from '@/http/ziggy';

/**
 * Fetch leader board items.
 *
 * @param {Number} experiment
 * @param {URLSearchParams} params
 * @return {*}
 */
export const fetchLeaderBoardItems = ({experiment, params}) => axios.get(route('catchers.scoring.experiment.leaderboards.index', {experiment}), {params});
